// import { useEffect } from 'react';

// import { useAuth } from '../../hooks/auth/useAuth';
// import useDialogContext from '../../hooks/dialog/useDialogContext';
import { useQueryClient } from '@tanstack/react-query';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { isCertificatesAnnouncementDismissedForSession } from '../../components/dialog-manager/dialogs/certificates-announcement-dialog/session-dismissal.utils';
import WebsocketContext, { WebsocketEventType } from '../../contexts/websocket/WebsocketContext';
import { useAuth } from '../../hooks/auth/useAuth';
import useDialogContext from '../../hooks/dialog/useDialogContext';
import useNotificationContext from '../../hooks/notification/useNotificationContext';
import Header from './components/header/Header';
import { createMessageHandlers } from './socket-message-handlers';

type AppLayoutProps = {
  children: React.ReactNode;
};

const AppLayout = ({ children }: AppLayoutProps) => {
  const { user, isCompanyAdmin } = useAuth();
  const { openDialog } = useDialogContext();

  useEffect(() => {
    if (isCompanyAdmin && !user?.isCompanyIdentifierExist) {
      openDialog('company-identifier-dialog');
    }
  }, [isCompanyAdmin, user?.isCompanyIdentifierExist]);

  useEffect(() => {
    const isEnabledByEnv = process.env.REACT_APP_CERTIFICATES_ANNOUNCEMENT_ENABLED === 'true';
    const isNotDismissedOnBackend =
      user != null && user.certificatesAnnouncementDismissedAt == null;
    const isNotDismissedForSession =
      user?.id != null && !isCertificatesAnnouncementDismissedForSession(user.id);

    if (isEnabledByEnv && isNotDismissedOnBackend && isNotDismissedForSession) {
      openDialog('certificates-announcement-dialog');
    }
  }, [user?.certificatesAnnouncementDismissedAt, user?.id]);

  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const { notify } = useNotificationContext();
  const { useRegisterCallback } = useContext(WebsocketContext);

  // Create callback functions for handling websocket messages
  const {
    requestPcfHandler,
    requestBulkPcfSingleCompletedHandler,
    requestBulkPcfSummaryHandler,
    importFileHandler,
    calculationPdfGeneratedHandler,
    requestUpdatedHandler,
    certificateExchangeHandler,
  } = createMessageHandlers({ queryClient, notify, t });

  // Register callback functions
  useRegisterCallback(WebsocketEventType.RequestPCF, requestPcfHandler);
  useRegisterCallback(
    WebsocketEventType.RequestBulkPcfSingleCompleted,
    requestBulkPcfSingleCompletedHandler,
  );
  useRegisterCallback(WebsocketEventType.RequestBulkPcfSummary, requestBulkPcfSummaryHandler);
  useRegisterCallback(WebsocketEventType.ImportFile, importFileHandler);
  useRegisterCallback(WebsocketEventType.CalculationPdfGenerated, calculationPdfGeneratedHandler);
  useRegisterCallback(WebsocketEventType.RequestUpdated, requestUpdatedHandler);
  useRegisterCallback(WebsocketEventType.CertificateExchange, certificateExchangeHandler);

  return (
    <div className='min-h-screen'>
      <Header />
      {children}
    </div>
  );
};

export default AppLayout;
